import { Button, Form, Input, Select, message } from 'antd'
import React, { useState, useRef, useEffect, Fragment } from 'react'
import User from '@/modules/user'
import CountDownBtn from '@/components/countDownBtn'
import styles from './pre.scss'
import { CheckCircleTwoTone } from '@ant-design/icons'
import { SYSCON } from '@/const/const'
import ProvinceCityDropdown from '@/components/City/index'
import { isMobileAgent, is_weixn } from '@/utils/utils'

const PreOrder = (props) => {
  // 属性
  const formRef = useRef()
  const [prods, handleProds] = useState([])
  const [appointmentVisible, handleVisiable] = useState(true)
  const countRef = React.createRef()
  const [showCityFlag, handleShowCityFlag] = useState(false)
  const [showProvinceNmFlag, handleProvinceNmFlag] = useState(false)
  const [provinceNm, setProvinceNm] = useState('') // 省份名称
  const [cityNm, setCityNm] = useState('') // 市名称

  // 用户初始化
  const user = new User()

  const [form] = Form.useForm()

  // 初始化
  useEffect(()=>{
    handleVisiable(true)
    async function getProds() {
      const user = new User()
      await user.getProdList(SYSCON.PlatAppSmarterFin).catch((err)=>{
        console.log('getProdListerr', err)
      })
      const prods = user.getProds()
      console.log('prods', prods)
      handleProds(prods)
    }
    getProds()
  }, [])

  // 预约请求
  const handleAppointment = (fields) => {
    // 加载信息
    const hide = message.loading('请稍等')
    let srcCd
    if (is_weixn()) {
      srcCd = SYSCON.ProdTrialSrcWxMp
    } else {
      srcCd = isMobileAgent() ? SYSCON.ProdTrialSrcWebsiteMobile : SYSCON.ProdTrialSrcWebsitePC
    }
    const data = {
      ...fields,
      srcCd: srcCd
    }
    user.onAppointment(data)
      .then((data) => {
        hide()
        if (data.status === 210) {
          message.error(data.msg)
          return
        }
        handleVisiable(false)
        setTimeout(()=>{
          form.resetFields()
        }, 300)
      })
      .catch(err => {
        countRef.current.handleReset()
        hide()
        console.log('err', err)
      })
  }
  // 处理预约
  const onFinish = async(values) => {
    if (!provinceNm || !cityNm) return
    const prod = prods.find((f) => f.id === values.prodLvlId)
    const reqData = { ...values, prodLvlId: (prod && prod.id) || '', prodLvlNm: (prod && prod.nm) || '', prodNm: (prod ? prod.prodNm : prods[0].prodNm), prodId: (prod ? prod.prodId : prods[0].prodId), provinceNm, cityNm }
    console.log('reqData', reqData)
    const result = await handleAppointment({ ...reqData })
    if (result) {
    }
  }

  const handleSend = () => {
    const { applicantPhone } = form.getFieldsValue()
    console.log('applicantPhone', applicantPhone)

    return checkPhoneValue(applicantPhone).then(()=>{
      user.sendCode({ phone: applicantPhone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }

  const phoneValid = () => ({
    validator(_, value) {
      return checkPhoneValue(value)
    }
  })

  const validateVcode = () => ({
    validator(_, value) {
      console.log('valuevaluevaluevaluevalue', value)
      if (value) {
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if ((cnReg.test(value))) {
          return Promise.reject(new Error('验证码不能为中文'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('验证码不能为空')
      }
    }
  })

  const checkPhoneValue = async(value)=>{
    console.log('value', value)

    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    console.log('value - 0', value - 0)

    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }

    return Promise.resolve()
  }

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  const handleCityData = (cityObj) => {
    setProvinceNm(cityObj.province)
    setCityNm(cityObj.city)
  }
  const validateCity = () => ({
    validator(_, value) {
      if (!provinceNm) {
        handleProvinceNmFlag(true)
      } else {
        handleProvinceNmFlag(false)
      }
      if (!cityNm) {
        handleShowCityFlag(true)
        return Promise.reject('')
      } else {
        handleShowCityFlag(false)
        return Promise.resolve()
      }
    }
  })
  return (
    <Fragment>
      {appointmentVisible ? (
        <div className={styles['pre-con']}>
          <p className={styles['title']}>预约智能财务系统</p>
          <p className={styles['tip']}>我们将在预约提交后尽快联系您，并对您的信息严格保密</p>
          <Form

            form={form}
            ref={formRef}
            onFinish={onFinish}
            name='appointment'

          >
            <Form.Item
              name='applicantNm'
              label='姓名：'
              rules={[
                { required: true, message: '姓名不能为空' },
                { max: 100, message: '不能超过100位' }
              ]}
            >
              <Input placeholder='请输入姓名' autoComplete='off'/>
            </Form.Item>
            <Form.Item
              name='applicantPhone'
              label='手机号：'

              rules={[
                { required: true, message: '手机号不能为空' },
                phoneValid
              ]}
            >
              <Input placeholder='请输入手机号' autoComplete='off'/>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }} label='验证码'>
              <Form.Item
                name='code'
                rules={[validateVcode]}
                style={{ display: 'inline-block', width: 'calc(74% - 8px)' }}
                getValueFromEvent = {cnInputCheck}
              >
                <Input placeholder='请输入验证码' autoComplete='off'/>
              </Form.Item>
              <Form.Item
                style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}
              >
                <CountDownBtn ref={countRef} handleSend={handleSend}/>
              </Form.Item>
            </Form.Item>
            <Form.Item
              name='rootOrgNm'
              label='企业名称：'
              rules={[
                { required: true, message: '企业名称不能为空' },
                { max: 100, message: '不能超过100位' }
              ]}
            >
              <Input placeholder='请输入企业名称' autoComplete='off'/>
            </Form.Item>
            <Form.Item
              name='provinceNm'
              label='所属地区：'
              rules={[validateCity]}
              required
            >
              <ProvinceCityDropdown styleSmallFlag={true} showProvinceNmFlag={showProvinceNmFlag} showCityFlag={showCityFlag} onChildClick={handleCityData} />
              { showCityFlag || showProvinceNmFlag ? <span style={{ color: '#ff4d4f', marginBottom: '-19px', display: 'block' }}>所属地区不能为空</span> : '' }
            </Form.Item>
            <Form.Item
              name='prodLvlId'
              label='试用版本：'
            >
              <Select
                placeholder='请选择'
                allowClear
              >
                {
                  prods && Array.isArray(prods) && prods.map((p) => {
                    return (<Select.Option key={p.id} value={p.id}>{p.nm}</Select.Option>)
                  })
                }
                <Select.Option value=''>不太清楚</Select.Option>

              </Select>
            </Form.Item>
            <Form.Item
              name='notes'
              label='备注说明：'
              rules={[
                { max: 100, message: '不能超过100位' }
              ]}
            >
              <Input placeholder='请填写备注' autoComplete='off' />
            </Form.Item>
            <div className={styles['btns']}>
              <Button type='primary' htmlType='submit' block >
             提交
              </Button>
            </div>

          </Form>
        </div>
      ) : (
        <div className={styles['suc-con']}>
          <CheckCircleTwoTone twoToneColor='#52c41a' className={styles['sicon']}/><span>提交成功，我们将尽快联系您！</span>
        </div>
      )}
    </Fragment>

  )
}

export default PreOrder
